import { createContext, useContext, useState } from "react";

const UserEmailContext = createContext();

export const UserEmailProvider = ({ children }) => {
  const [userEmail, setUserEmail] = useState(
    localStorage.getItem("check2UserEmail") || null,
  );

  return (
    <UserEmailContext.Provider value={{ userEmail, setUserEmail }}>
      {children}
    </UserEmailContext.Provider>
  );
};

export const useUserEmail = () => {
  const context = useContext(UserEmailContext);

  if (!context) {
    throw new Error("useUserEmail must be used within UserEmailProvider");
  }

  return context;
};
